import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import authService from '../api/authService';
import Toast from '../components/Toast';

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [verified, setVerified] = useState(false);
  const [error, setError] = useState('');
  const [toast, setToast] = useState({ message: '', type: 'success' });

  const showToast = (message, type = 'success') => setToast({ message, type });
  const hideToast = () => setToast({ message: '', type: 'success' });

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const token = searchParams.get('token');

        if (!token) {
          setError('Token de vérification manquant');
          setLoading(false);
          return;
        }

        const response = await authService.verifyEmail(token);
        setVerified(true);
        showToast(response.data.message || 'Email vérifié avec succès !', 'success');

        // Redirect to login after 2 seconds
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      } catch (err) {
        const errorMessage = err?.response?.data?.message || err?.message || 'Erreur lors de la vérification';
        setError(errorMessage);
        showToast(errorMessage, 'danger');
        setLoading(false);
      }
    };

    verifyEmail();
  }, [searchParams, navigate]);

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      backgroundColor: '#f5f5f5',
      padding: '20px'
    }}>
      <Toast message={toast.message} type={toast.type} onClose={hideToast} />
      
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        padding: '40px',
        maxWidth: '500px',
        width: '100%',
        textAlign: 'center'
      }}>
        {loading && !verified && !error ? (
          <>
            <Spinner animation="border" style={{ color: '#8B0000', marginBottom: '20px' }} />
            <h4 style={{ color: '#333', marginBottom: '10px' }}>Vérification en cours...</h4>
            <p style={{ color: '#666' }}>Veuillez patienter pendant que nous vérifions votre email.</p>
          </>
        ) : verified ? (
          <>
            <div style={{ 
              width: '60px', 
              height: '60px', 
              borderRadius: '50%', 
              backgroundColor: '#d4edda', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              margin: '0 auto 20px'
            }}>
              <span style={{ fontSize: '30px', color: '#155724' }}>✓</span>
            </div>
            <h3 style={{ color: '#155724', marginBottom: '10px' }}>Email vérifié !</h3>
            <p style={{ color: '#666', marginBottom: '20px' }}>
              Votre adresse email a été vérifiée avec succès. 
              Vous allez être redirigé vers la page de connexion.
            </p>
          </>
        ) : error ? (
          <>
            <div style={{ 
              width: '60px', 
              height: '60px', 
              borderRadius: '50%', 
              backgroundColor: '#f8d7da', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              margin: '0 auto 20px'
            }}>
              <span style={{ fontSize: '30px', color: '#721c24' }}>✕</span>
            </div>
            <h3 style={{ color: '#721c24', marginBottom: '10px' }}>Erreur de vérification</h3>
            <p style={{ color: '#666', marginBottom: '20px' }}>{error}</p>
            <button 
              onClick={() => navigate('/login')}
              style={{
                backgroundColor: '#8B0000',
                color: 'white',
                border: 'none',
                padding: '10px 30px',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Retour à la connexion
            </button>
          </>
        ) : null}
      </div>
    </div>
  );
}
